import Tag from 'antd/lib/tag';
import React from 'react';
import { INominationReadinessTrack, NominationReadinessTrackStatus } from '../../../domain/nomination/readiness/interface';
import { DISABLED_COLOR, ERROR_COLOR, INFO_COLOR, PRIMARY_COLOR } from '../../../theme';

type STATUS_VALUE = { color: string; text: string };

const STATUS_CONFIG: Record<NominationReadinessTrackStatus, STATUS_VALUE> = {
    [NominationReadinessTrackStatus.READY_FOR_CUSTOMER_REVIEW]: { color: INFO_COLOR, text: 'Ready for Customer Review' },
    [NominationReadinessTrackStatus.SCHEDULED]: { color: INFO_COLOR, text: 'Scheduled' },
    [NominationReadinessTrackStatus.SENT]: { color: INFO_COLOR, text: 'Sent' },
    [NominationReadinessTrackStatus.SKIPPED]: { color: DISABLED_COLOR, text: 'Skipped' },
    [NominationReadinessTrackStatus.CONFIRMED]: { color: PRIMARY_COLOR, text: 'Confirmed' },
    [NominationReadinessTrackStatus.REJECTED]: { color: ERROR_COLOR, text: 'Rejected' },
};

interface IReadinessTrackingStatusTagProps {
    nominationReadinessTrack?: INominationReadinessTrack | null;
}

export const NominationStatusTag: React.FC<IReadinessTrackingStatusTagProps> = ({ nominationReadinessTrack }) => {
    const status = nominationReadinessTrack?.status || NominationReadinessTrackStatus.READY_FOR_CUSTOMER_REVIEW;
    const { color, text } = STATUS_CONFIG[status];

    return <Tag color={color}>{text}</Tag>;
};
